import { AdvCoreFilter, LmsTrainingOrder } from "generated/CoreApi_v1";
import LibUtils from "lib/LibUtils";

export interface ITopicFilterOptions {
    includeDescendants: boolean;
    searchText: string;
    advFilters: AdvCoreFilter[];
    order: LmsTrainingOrder;
}

export function getClearFilter(includeDescendants: boolean, order?: LmsTrainingOrder): ITopicFilterOptions {
    return {
        includeDescendants: includeDescendants,
        searchText: "",
        advFilters: [],
        order: order ?? LmsTrainingOrder.Name
    };
}

export function filterChanged(filter: ITopicFilterOptions, compare: ITopicFilterOptions) {
    return filter.searchText != compare.searchText
        || filter.order != compare.order
        || !LibUtils.compareObjects(filter.advFilters.map(x => x.command), compare.advFilters.map(x => x.command))
        || !LibUtils.compareObjects(filter.advFilters, compare.advFilters);
}
